<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <g>
    <path class="cls-1" d="m26.64,15.15h-12.76c-.7,0-1.26-.56-1.26-1.26s.56-1.26,1.26-1.26h12.76c.7,0,1.26.56,1.26,1.26s-.56,1.26-1.26,1.26Z"/>
    <path class="cls-1" d="m13.88,27.9c-.7,0-1.26-.56-1.26-1.26v-12.76c0-.7.56-1.26,1.26-1.26s1.26.56,1.26,1.26v12.76c0,.7-.56,1.26-1.26,1.26Z"/>
    <path class="cls-1" d="m13.88,77.38c-.7,0-1.26-.56-1.26-1.26v-12.76c0-.7.56-1.26,1.26-1.26s1.26.56,1.26,1.26v12.76c0,.7-.56,1.26-1.26,1.26Z"/>
    <path class="cls-1" d="m26.64,77.38h-12.76c-.7,0-1.26-.56-1.26-1.26s.56-1.26,1.26-1.26h12.76c.7,0,1.26.56,1.26,1.26s-.56,1.26-1.26,1.26Z"/>
    <path class="cls-1" d="m76.12,77.38h-12.76c-.7,0-1.26-.56-1.26-1.26s.56-1.26,1.26-1.26h12.76c.7,0,1.26.56,1.26,1.26s-.56,1.26-1.26,1.26Z"/>
    <path class="cls-1" d="m76.12,77.38c-.7,0-1.26-.56-1.26-1.26v-12.76c0-.7.56-1.26,1.26-1.26s1.26.56,1.26,1.26v12.76c0,.7-.56,1.26-1.26,1.26Z"/>
    <path class="cls-1" d="m76.12,27.9c-.7,0-1.26-.56-1.26-1.26v-12.76c0-.7.56-1.26,1.26-1.26s1.26.56,1.26,1.26v12.76c0,.7-.56,1.26-1.26,1.26Z"/>
    <path class="cls-1" d="m76.12,15.15h-12.76c-.7,0-1.26-.56-1.26-1.26s.56-1.26,1.26-1.26h12.76c.7,0,1.26.56,1.26,1.26s-.56,1.26-1.26,1.26Z"/>
  </g>
  <path class="cls-2" d="m46.13,29.57l3.96,8.03c.18.37.54.63.95.69l8.86,1.29c1.04.15,1.45,1.42.7,2.15l-6.41,6.25c-.3.29-.43.71-.36,1.12l1.51,8.83c.18,1.03-.91,1.82-1.83,1.33l-7.93-4.17c-.37-.19-.81-.19-1.18,0l-7.93,4.17c-.93.49-2.01-.3-1.83-1.33l1.51-8.83c.07-.41-.07-.83-.36-1.12l-6.41-6.25c-.75-.73-.34-2,.7-2.15l8.86-1.29c.41-.06.77-.32.95-.69l3.96-8.03c.46-.94,1.8-.94,2.27,0Z"/>
  <path class="cls-3" d="m45,68.22c-12.73,0-23.09-10.36-23.09-23.09s10.36-23.09,23.09-23.09,23.09,10.36,23.09,23.09-10.36,23.09-23.09,23.09Zm0-43.67c-11.34,0-20.57,9.23-20.57,20.57s9.23,20.57,20.57,20.57,20.57-9.23,20.57-20.57-9.23-20.57-20.57-20.57Z"/>
</svg>
</template>

<script>
export default {
    name: "TopItemSnapshotIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #b9e0d1;
  }
  .cls-3 {
    fill: #59c5c7;
  }
</style>